import MicroModal from 'micromodal';
import $ from 'jquery';
import loadScript from './../features/loader';


export function modal(unique) {
  MicroModal.init({
    openTrigger: `data-popup-${unique}`,
    disableScroll: true,
  });
}

export function galleryZoom(container) {
  const $triggers = $(container).find('[data-image-zoom]');
  $.each($triggers, function(index, trigger) {
    const $trigger = $(trigger);
    const unique = $trigger.attr('data-unique');

    MicroModal.init({
      disableScroll: true,
      openTrigger: `data-popup-${unique}`,
      onShow: (modal) => {
        var $images = $('[data-src]', modal);
        $images.each(function () {
          var $image = $(this);
          if ($image.attr('src') === undefined) {
            $image.attr('src', $image.attr('data-src'));
          }
        });
      },
    });
  });
}

export function productZoom(container, json) {

  const loadedPromise = loadScript({url: window.theme.assets.photoswipe});
  const returnZoom = loadedPromise.then(() => {

    const PhotoSwipe = window.pipelinePhotoswipe.PhotoSwipe.default;
    const PhotoSwipeUI = window.pipelinePhotoswipe.PhotoSwipeUI.default;

    const triggers = container.querySelectorAll('[data-zoom-button]');
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const el = container.querySelector('[data-zoom-wrapper]');
        const dataId = event.target.closest('[data-media-id]').getAttribute('data-media-id').toString();
        const items = [];
        for (let i = 0; i < json.media.length; i++) {
          items[items.length] = {
            src: json.media[i].src,
            w: json.media[i].width,
            h: json.media[i].height,
            id: json.media[i].id,
          };
        }
        const findImage = (element) => element.id.toString() === dataId;
        const index = items.findIndex(findImage);
        const options = {
          index,
          showHideOpacity: true,
          showAnimationDuration: 150,
          hideAnimationDuration: 250,
          bgOpacity: 1,
          spacing: 0,
          allowPanToNext: false,
          maxSpreadZoom: 3,
          history: false,
          loop: true,
          pinchToClose: false,
          modal: false,
          closeOnScroll: false,
          closeOnVerticalDrag: true,
          getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
            if (isMouseClick) {
              return 1.67;
            } else {
              return item.initialZoomLevel < 0.7 ? 1 : 1.3;
            }
          },
          getThumbBoundsFn: function getThumbBoundsFn() {
            const imageLocation = container.querySelector('[data-product-slideshow]');
            const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            const rect = imageLocation.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
        };
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
        // Initializes and opens PhotoSwipe
        const gallery = new PhotoSwipe(el, PhotoSwipeUI, items, options);
        gallery.init();
        gallery.listen('close', function() {
          document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
        });
      });
    });
  }).catch((e) => console.error(e));
  return returnZoom;
}
